var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5355 6.46444C15.4882 8.41707 15.4882 11.5829 13.5355 13.5355M6.46447 13.5355C4.51185 11.5829 4.51185 8.41704 6.46447 6.46442M4.10745 15.8925C0.853079 12.6382 0.853079 7.36179 4.10745 4.10742M15.8926 4.10746C19.1469 7.36183 19.1469 12.6382 15.8926 15.8926M11.6667 9.99998C11.6667 10.9205 10.9205 11.6666 10 11.6666C9.07953 11.6666 8.33334 10.9205 8.33334 9.99998C8.33334 9.0795 9.07953 8.33331 10 8.33331C10.9205 8.33331 11.6667 9.0795 11.6667 9.99998Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.d251e96083b066acaaeffd4d2146ce09.svg";
export { ForwardRef as ReactComponent };